import React, {useEffect, useRef, useState} from 'react';
import UButton from "ubs-framework/v2/UButton";
import UModal from "ubs-framework/v2/UModal/NewUModal";
import UInput from "ubs-framework/v2/UInput";
import UDatePicker from "ubs-framework/v2/UDatePicker";
import Validator from "simple-react-validator";
import {useForceUpdate} from "ubs-framework/v2/hooks/useForceUpdate";
import {errorFocus, getName} from "ubs-framework/v2/common/function";
import useSocket from "../../common/hooks/useSocket";
import URadio from "ubs-framework/v2/URadio";
import {REMINDER} from "../../../common/constant";
import AsyncEmployeeSelect from "../../common/employee-access-select/async-employee-select";
import {sendData} from "../../../store/actions";
import {useSelector} from "react-redux";

const SetReminder = React.memo((props) => {
    const forceUpdate = useForceUpdate();
    const validator = useRef(new Validator({element: (message) => <>{message}</>, autoForceUpdate: {forceUpdate}}));

    const _USERS = useSelector(e => e?.ats?.userObj || {});
    const _ID = useSelector(e => e.common?._id);

    const [loader, setLoader] = useState(false);
    const [allValues, setAllValues] = useState({
        candidate: '',
        reminderType: REMINDER.TYPE.ME,
        date: new Date(),
        note: '',
        to: []
    })

    const handle = {
        clear: (name) => {
            validator.current.hideMessageFor(name)
            validator.current.errorMessages[name] = undefined
            delete validator.current.errorMessages[name]
            validator.current.fields[name] = true
        },
        change: (e, name) => {
            const data = {[name]: e}
            if(name ==='reminderType' && e === REMINDER.TYPE.ME) {
                handle.clear('to')
            }
            setAllValues({...allValues, ...data});
        },
        addCandidate: e => {
            if (validator?.current?.allValid()) {
                const data = {
                    candidate: allValues?.candidate?.value,
                    reminderType: allValues?.reminderType,
                    date: new Date(allValues?.date).getTime(),
                    note: allValues?.note,
                }
                if(allValues?.reminderType === REMINDER.TYPE.SELECTED) data.to = allValues?.to?.map(e => e?.value)
                else data.to = [_ID]
                if(!!props?.editData && props?.editData?._id) data._id = props?.editData?._id
                setLoader(true)
                if(!!props?.editData && data._id) sendData('ats|candidate-reminder|update', data);
                else sendData('ats|candidate-reminder|add', data);
            } else {
                validator?.current?.showMessages();
                setLoader(false)
                errorFocus();
            }
        },
        close: e => {
            props.close()
        }
    }

    const {on, off, refresh} = useSocket(res => {
        if (!res.error) {
            switch (res.event) {
                case 'ats|candidate-reminder|add':
                case 'ats|candidate-reminder|update':
                    setLoader(false)
                    props?.close()
                    break
                default:
                    return true;
            }
        } else {
            switch (res.event) {
                case 'ats|candidate-reminder|add':
                case 'ats|candidate-reminder|update':
                    setLoader(false)
                    break
                default:
                    return true;
            }
        }
    });
    useEffect(() => {
        refresh()
        return () => off()
    }, [])
    useEffect(() => {
        if(props?.editData) {
            const to = []
            if (props?.editData?.to?.length) props?.editData?.to?.forEach(e => {
                if(_USERS[e]) to.push(_USERS[e])
            })
            setAllValues({
                candidate: {
                    value: props?.editData?.candidateInfo?._id,
                    label: getName(props?.editData?.candidateInfo)
                },
                reminderType: props?.editData?.reminderType ?? REMINDER.TYPE.ME,
                date: props?.editData?.date ? new Date(props?.editData?.date) : new Date(),
                note: props?.editData?.note ?? '',
                to
            })
        }
    }, [props?.editData])

    return (
        <React.Fragment>
            <UModal
                open={true}
                maxWidth={675}
                header={<h4>Set Reminder</h4>}
                onClose={() => handle.close()}
            >
                <div className="u_p-15">
                    <div className="u_row">
                        <div className="u_col-6 u_mb-15">
                            <UInput label="Candidate" select asterisk selectValue={allValues?.candidate} hasError={validator.current.message('candidate', allValues?.candidate, 'required')}>
                                <AsyncEmployeeSelect
                                    value={allValues?.candidate}
                                    onChange={(e) => handle.change(e, 'candidate')}
                                    params={{menuPlacement: 'auto', isDisabled: !!props?.editData}}
                                    candidate={true}
                                    requestData={{type: 'reminder'}}
                                />
                            </UInput>
                        </div>
                    </div>

                    <div className="u_row">
                        <div className="u_col-6 u_mb-15">
                            <URadio
                                id={`reminderToMe`}
                                name={`reminderType`}
                                label="Reminder to me"
                                htmlFor={`reminderToMe`}
                                className="u_mb-15"
                                checked={allValues?.reminderType === REMINDER.TYPE.ME}
                                onChange={e => handle.change(REMINDER.TYPE.ME, 'reminderType')}
                            />
                        </div>
                        <div className="u_col-6 u_mb-15">
                            <URadio
                                id={`ReminderToOther`}
                                name={`reminderType`}
                                label="Reminder to selected person"
                                htmlFor={`ReminderToOther`}
                                className="u_mb-15"
                                checked={allValues?.reminderType === REMINDER.TYPE.SELECTED}
                                onChange={e => handle.change(REMINDER.TYPE.SELECTED, 'reminderType')}
                            />
                        </div>
                    </div>

                    <div className="u_row">
                        {allValues?.reminderType === REMINDER.TYPE.SELECTED && <div className="u_col-6 u_mb-15">
                            <UInput label="Reminder to" select asterisk selectValue={allValues?.to} hasError={allValues?.reminderType === REMINDER.TYPE.SELECTED && validator.current.message('to', allValues?.to, 'required')}>
                                <AsyncEmployeeSelect
                                    value={allValues?.to}
                                    onChange={(e) => handle.change(e, 'to')}
                                    params={{isMulti: true, menuPlacement: 'auto'}}
                                    checkVisibility={false}
                                />
                            </UInput>
                        </div>}
                        <div className="u_col-6 u_mb-15">
                            <UInput label={'Select Date & Time'} datepicker
                                    selectDate={allValues?.date ? new Date(allValues?.date) : null}
                                    hasError={(validator.current.message('date', new Date(allValues?.date), 'required'))}
                                    className="u_datetime-picker">
                                <UDatePicker
                                    minDate={new Date()}
                                    selected={allValues?.date ? new Date(allValues?.date) : null}
                                    onChange={(e) => handle.change(e, 'date')}
                                    dateFormat="dd/MM/yy h:mm aa"
                                    timeIntervals={10}
                                    name="date"
                                    placeholderText=" "
                                    popperPlacement="bottom-start"
                                    showTimeSelect
                                />
                            </UInput>
                        </div>
                    </div>

                    <div className="u_row">
                        <div className="u_col-12 u_mb-15">
                            <UInput label="Add Note" textarea asterisk hasError={validator?.current?.message("note", allValues?.note, "required|max:500,string")}>
                                <textarea
                                    className={`u_textarea u_textarea-six-rows`}
                                    placeholder=" "
                                    name="note"
                                    value={allValues?.note}
                                    autoComplete="off"
                                    maxLength={500}
                                    onChange={e => handle.change(e?.target?.value, 'note')}
                                />
                            </UInput>
                        </div>
                    </div>

                </div>
                <div className="u_modal-buttons">
                    <UButton disabled={loader} loading={loader} variant="white" type="Cancel" onClick={(e) => handle.close()}/>
                    <UButton disabled={loader} loading={loader} isSubmit variant="blue" type="Save" cn="u_ml-10" onClick={handle.addCandidate}/>
                </div>
            </UModal>
        </React.Fragment>
    );
});

export default SetReminder;
